import Select from "react-select";
import classes from "./Dropdown.module.scss";

const Dropdown = ({ options, value, onChange, isSearchable = false, placeholder, isDisabled=false, onBlur }) => {
  // Custom styles for the dropdown
  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "none",
      borderRadius: "10px",
      backgroundColor: "#d9d9d9",
      padding: "2px",
    }),
    option: (provided) => ({
      ...provided,
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
    }),
    singleValue: (provided) => ({
      ...provided,
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
    }),
    placeholder: (provided) => ({
      ...provided,
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  return (
    <Select
      options={options}
      isSearchable={isSearchable}
      placeholder={placeholder}
      className={classes.dropdown}
      styles={customStyles}
      value={value}
      onChange={(selected) => onChange(selected?.value)}
      onMenuOpen={onBlur}
      isDisabled={isDisabled}
    />
  );
};

export default Dropdown;
